import { useEffect, useState } from "react";
import { useReportsPageModel } from "./ReportPageModel"
import { CustomTable } from "./CustomTable";
import { Autocomplete, Box, Button, CircularProgress, Divider, Pagination, PaginationItem, Paper, Popper, Tab, TextField, Typography } from "@mui/material";
import { NavLink, useParams } from "react-router-dom";
import { activeColor, buttonStyle } from "../Meds/styles/styles";
import { GearIcon } from "../../modules/Sidebar/assets/GearIcon";
import { DownloadIcon } from "./assets/DownloadIcon";
import { MedCardStatuses } from "../Meds/types";
import { downloadFile } from "./drawers/ReportCard";
import { makeStyles } from '@mui/styles'
import { excelArgs, getExcelReportTableRequest } from "../../services/fileService";
import { ViewSettingsModal } from "./components/ViewSettingsModal";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useReferralModel } from "./ReportReferralModel";
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { useMedJournalModel } from "./MedJournalModel";
import { ReportGenerationModal } from "./modals/ReportGeneratingModal";
import { ModalNames, setMedJournalAwaiting } from "../../slices/AppSlice";
import { useAppDispatch } from "../../store/hooks/redux";
import moment from "moment";
import { useModal } from "../../modules/layout/components/modals/useModal";

const tabStyle = {
    fontWeight: '500',
    fontSize: '16px',
    color: '#BDBDBD',
    textTransform: 'none',
    padding: '0px 4px 0px 4px',
    marginTop: '16px',
    minHeight: '32px',
    '&.Mui-selected': {
        color: '#009FDA',
    },
}

const autocompleteNumberStyle = {
    maxWidth: '60px', maxHeight: '32px', 
    '& .MuiInputBase-root': {padding: '4px 0px 0px 8px', fontSize: '16px', '& .MuiInputBase-input': {padding: '2px 4px 6px 4px', color: '#565656'}}, 
    '& .MuiAutocomplete-popupIndicator': {margin: '2px -6px 0px 0px', color: '#BDBDBD', scale: '1.3', '&.MuiAutocomplete-popupIndicatorOpen': {transform: 'rotate(-90deg)', transition: '0.1s ease-out',}},
    '& .MuiButtonBase-root': {padding: '0px'}, '& :not(focused)': { transition: 'all 0.1s ease-out' },
    '& .MuiOutlinedInput-root': {'&.Mui-focused': {transition: '0.1s ease-out', boxShadow: '0px 0px 0px 1px #FFF inset', borderColor: '#FFF'}}
} 
const autocompletePaper = {
    //maxHeight: '200px',
}
const autocompletePopper = {
    '*::-webkit-scrollbar': {
        width: '0.5em'
    },
    '*::-webkit-scrollbar-track': {
        backgroundColor: '#EEEEEE',
    },
    '*::-webkit-scrollbar-thumb': {
        backgroundColor: '#BFBFBF',
        borderRadius: '2px',
    },
}


export const ReportPage = () => {


    const reportModel = useReportsPageModel()
    const referralModel = useReferralModel()
    const medJournalModel = useMedJournalModel(reportModel.tabValue)

    const [exelLoading, setExelLoading] = useState<boolean>(false)
    const dispatch = useAppDispatch();
    const { changeCurrentModal } = useModal()

    const getExcelReportTable = async (api_url: string) => {
            if (api_url) {
              setExelLoading(true)
              let filterRequest_corrected
              if (reportModel?.filterRequest?.createdAt) {
                const { gte, lte } = reportModel?.filterRequest?.createdAt
                const start = moment(gte.replace('Z', ''))
                const end = moment(lte.replace('Z', ''))
                const diff = end.diff(start, 'days')+1
                const monthDays = Math.min(
                  start.clone().startOf('month').daysInMonth(),
                  end.clone().startOf('month').daysInMonth()
                )
                if (diff > monthDays) {
                  if (gte === "1970-01-01T00:00:00Z") {
                    filterRequest_corrected = {
                      ...reportModel.filterRequest,
                      createdAt: {
                        ...reportModel?.filterRequest?.createdAt,
                        gte: end.clone().subtract(1, 'month').startOf('day').format('YYYY-MM-DDTHH:mm:ss')+'Z'
                      }
                    }
                  } else {
                    filterRequest_corrected = {
                      ...reportModel.filterRequest,
                      createdAt: {
                        ...reportModel?.filterRequest?.createdAt,
                        lte: start.clone().add(1, 'month').endOf('day').format('YYYY-MM-DDTHH:mm:ss')+'Z'
                      }
                    }
                  }
                }
              }
              getExcelReportTableRequest(
                api_url, {
                  ...(filterRequest_corrected ?? reportModel.filterRequest),
                  ...reportModel.sortingRequest
                }
              ).then((response) => {
                if (response.status === 201) {
                  setExelLoading(false)
                  medJournalModel.setOpenModal(true)
                  medJournalModel.getMedJournalsReports()
                  // dispatch(setMedJournalAwaiting({id: response?.data?.id, api: medJournalModel.reportsApi.api_url.slice(0, -3), interval: null}))
                } else {
                  changeCurrentModal(ModalNames.REPORT_ERROR)
                  setExelLoading(false)
                }
              })
            }
    }

    const useStyles: any = makeStyles((theme: any) => ({
        selected: {
            backgroundColor: 'blue',
            color: 'white',
        },
    }),
    );
    const classes = useStyles();

    return (
        <Box>
            {/* <Divider sx={{color:'#EEEEEE'}}></Divider>
             <Box sx={{ backgroundColor: 'white', padding: '16px 24px' }}>
            <   Typography sx={{ fontFamily: 'Roboto', fontSize: '24px', fontWeight: '500', lineHeight: '32px' }}>Отчеты</Typography>
            </Box> */}
            <ReportGenerationModal open={medJournalModel.openModal} setOpen={medJournalModel.setOpenModal} />
            <TabContext value={reportModel.tabValue}>
            <Box sx={{ backgroundColor: 'white', margin: '0 16px 0 16px' }}>
            <div style={{ zIndex: 2, margin: '0px 16px 0px 16px', borderTop: '1px solid #EEE' }} />
            </Box>
            <Box sx={{ backgroundColor: 'white', borderRadius: '0px 0px 4px 4px', padding: '16px 24px 0px 24px', margin: '0px 16px 0 16px', position: 'sticky', top: '65px', zIndex: '9'}}>
                <Typography sx={{ fontFamily: 'Roboto', fontSize: '24px', fontWeight: '500', lineHeight: '32px' }}>Медосмотры</Typography>
                <TabList 
                    sx={{marginTop: '-10px', '& .MuiTabs-indicator': {backgroundColor: '#009FDA'}, '& .MuiTabs-flexContainer': {gap: '16px'}}} 
                    onChange={(_, value) => reportModel.setTabValue(value)} 
                    >
                        <Tab sx={tabStyle} label='Отчёты' value={'MED_LOG'} />
                        <Tab sx={tabStyle} label='Направления к врачу' value={'MED_REFERRAL'} />
                        <Tab sx={tabStyle} label='Медицинский журнал' value={'MED_JOURNAL'} />
                </TabList>
            </Box>

            <TabPanel value={'MED_LOG'} sx={{width: '100%', height: '100%', margin: '0px', padding: '0px'}}>

                <Paper
                    sx={{
                        margin:'17px 16px 15px 16px',
                        boxShadow: 'none',
                        padding: '16px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px'
                    }}
                >


                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontFamily: 'Roboto', fontWeight: '400', fontSize: '20px', lineHeight: '23px' }}>
                            Отчёты
                        </Typography>
                        <Box sx={{ display: 'flex', gap: '16px' }}>
                            <Button
                                onClick={() => { getExcelReportTable(reportModel.reportsApi?.baseUrl.slice(0, -3)) }}
                                variant="contained"
                                startIcon={exelLoading ? <CircularProgress sx={{color: '#FFFFFF'}} size={'20px'}/> : <DownloadIcon />}
                                sx={{
                                    ...buttonStyle, backgroundColor: activeColor,
                                    '&:hover': { backgroundColor: '#007DB8', boxShadow: 'none' },
                                    fontFamily: 'Roboto',
                                    fontWeight: '500',
                                    fontSize: '14px',
                                    lineHeight: '23px',
                                    padding: '8px 12px',
                                }}
                                disabled={reportModel.reportsApi === undefined || medJournalModel.medJournalAwaiting !== null || exelLoading}
                            >
                                Сформировать журнал
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    ...buttonStyle, backgroundColor: activeColor,
                                    '&:hover': { backgroundColor: '#007DB8', boxShadow: 'none' },
                                    fontFamily: 'Roboto',
                                    fontWeight: '500',
                                    fontSize: '14px',
                                    lineHeight: '23px',
                                    padding: '8px 12px',
                                    minWidth: '0px',
                                }}
                                disabled={reportModel.reportsApi === undefined}
                                onClick={() => reportModel.setOpenViewSettings(!reportModel.openViewSettings)}
                            >
                                <GearIcon />
                            </Button>
                        </Box>
                    </Box>


                    <CustomTable
                      openDrawer={true}
                      data={reportModel.reports}
                      columns={reportModel.columns}
                      setFilterRequest={reportModel.setFilterRequest}
                      reportsStatistics={reportModel.reportsStatistics}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', color: '#565656' }}>
                            Показывать
                            <Autocomplete
                                onInputChange={(_, value) => {reportModel.setPerPage((prev:number)=>{
                                    if (!value.match(/^(\s*|\d+)$/)) return prev
                                    if (value.length > 1 && value[0] === '0') return prev
                                    if (Number(value) > 50) return prev
                                    return Number(value)
                                })}}
                                inputValue={reportModel.perPage ? reportModel.perPage.toString() : ''}
                                sx={autocompleteNumberStyle}
                                freeSolo forcePopupIcon disableClearable
                                filterOptions={(opt)=>opt}
                                popupIcon={<KeyboardArrowRightRoundedIcon />}
                                PaperComponent={(props) => (<Paper elevation={2} {...props} sx={autocompletePaper} />)}
                                PopperComponent={(props) => ( <Popper {...props} sx={autocompletePopper} />)}
                                options={Array.from(new Array(50)).map((e, i)=>i+1)}
                                renderInput={(params)=><TextField {...params} placeholder="0"/>}
                            />
                            из {50}
                        </Box>
                        <Pagination
                            count={reportModel.pageQty}
                            page={reportModel.page}
                            onChange={(_, num) => reportModel.changePage(num)}
                            className={classes.root}
                            variant="outlined" shape="rounded"
                            sx={{
                                //marginY: 3, marginX: "auto",
                                '&  .Mui-selected': {
                                    backgroundColor: '#009FDA !important',
                                    color: 'white !important'
                                },
                                '& .Mui-selected:hover': {
                                    backgroundColor: 'rgb(0,159,218) !important',
                                    color: 'white !important'
                                },
                            }}
                            renderItem={(item) => (
                                <PaginationItem

                                    {...item}

                                    component={NavLink}
                                    to={`/reports/${item.page}`}
                                // to={'/organisations'}

                                />
                            )}
                        />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', color: '#565656' }}>
                            Страница
                            <Autocomplete
                                onInputChange={(_, value) => {reportModel.changePage((prev:number)=>{
                                    if (!value.match(/^(\s*|\d+)$/)) return prev
                                    if (value.length > 1 && value[0] === '0') return prev
                                    if (Number(value) > reportModel.pageQty) return prev
                                    return Number(value)
                                })}}
                                inputValue={reportModel.page ? reportModel.page.toString() : ''}
                                sx={autocompleteNumberStyle}
                                freeSolo forcePopupIcon disableClearable
                                filterOptions={(opt)=>opt}
                                popupIcon={<KeyboardArrowRightRoundedIcon />}
                                PaperComponent={(props) => (<Paper elevation={2} {...props} sx={autocompletePaper} />)}
                                PopperComponent={(props) => ( <Popper {...props} sx={autocompletePopper} />)}
                                options={Array.from(new Array(reportModel.pageQty)).map((e, i)=>i+1)}
                                renderInput={(params)=><TextField {...params} placeholder="0"/>}
                            />
                            из {reportModel.pageQty}
                        </Box>
                    </Box>

                    <ViewSettingsModal 
                        open={reportModel.openViewSettings} 
                        setOpen={reportModel.setOpenViewSettings} 
                        columns={reportModel.columns}
                        setColumns={reportModel.setColumns}
                    />

                </Paper>

            </TabPanel>

            <TabPanel value={'MED_REFERRAL'} sx={{width: '100%', height: '100%', margin: '0px', padding: '0px'}}>

                <Paper
                    sx={{
                        margin:'17px 16px 15px 16px',
                        boxShadow: 'none',
                        padding: '16px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px'
                    }}
                >


                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontFamily: 'Roboto', fontWeight: '400', fontSize: '20px', lineHeight: '23px' }}>
                            Направления к врачу
                        </Typography>
                        <Box sx={{ display: 'flex', gap: '16px' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    ...buttonStyle, backgroundColor: activeColor,
                                    '&:hover': { backgroundColor: '#007DB8', boxShadow: 'none' },
                                    fontFamily: 'Roboto',
                                    fontWeight: '500',
                                    fontSize: '14px',
                                    lineHeight: '23px',
                                    padding: '8px 12px',
                                    minWidth: '0px',
                                }}
                                disabled={reportModel.reportsApi === undefined}
                                onClick={() => referralModel.setOpenViewSettings(!referralModel.openViewSettings)}
                            >
                                <GearIcon />
                            </Button>
                        </Box>
                    </Box>

                    <CustomTable openDrawer={false} data={referralModel.referrals} columns={referralModel.columns} setFilterRequest={referralModel.setFilterRequest}></CustomTable>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', color: '#565656' }}>
                            Показывать
                            <Autocomplete
                                onInputChange={(_, value) => {referralModel.setPerPage((prev:number)=>{
                                    if (!value.match(/^(\s*|\d+)$/)) return prev
                                    if (value.length > 1 && value[0] === '0') return prev
                                    if (Number(value) > 50) return prev
                                    return Number(value)
                                })}}
                                inputValue={referralModel.perPage ? referralModel.perPage.toString() : ''}
                                sx={autocompleteNumberStyle}
                                freeSolo forcePopupIcon disableClearable
                                filterOptions={(opt)=>opt}
                                popupIcon={<KeyboardArrowRightRoundedIcon />}
                                PaperComponent={(props) => (<Paper elevation={2} {...props} sx={autocompletePaper} />)}
                                PopperComponent={(props) => ( <Popper {...props} sx={autocompletePopper} />)}
                                options={Array.from(new Array(50)).map((e, i)=>i+1)}
                                renderInput={(params)=><TextField {...params} placeholder="0"/>}
                            />
                            из {50}
                        </Box>
                        <Pagination
                            count={referralModel.pageQty}
                            page={referralModel.page}
                            onChange={(_, num) => referralModel.changePage(num)}
                            className={classes.root}
                            variant="outlined" shape="rounded"
                            sx={{
                                //marginY: 3, marginX: "auto",
                                '&  .Mui-selected': {
                                    backgroundColor: '#009FDA !important',
                                    color: 'white !important'
                                },
                                '& .Mui-selected:hover': {
                                    backgroundColor: 'rgb(0,159,218) !important',
                                    color: 'white !important'
                                },
                            }}
                            renderItem={(item) => (
                                <PaginationItem

                                    {...item}

                                    component={NavLink}
                                    to={`/reports/${item.page}`}
                                // to={'/organisations'}

                                />
                            )}
                        />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', color: '#565656' }}>
                            Страница
                            <Autocomplete
                                onInputChange={(_, value) => {referralModel.changePage((prev:number)=>{
                                    if (!value.match(/^(\s*|\d+)$/)) return prev
                                    if (value.length > 1 && value[0] === '0') return prev
                                    if (Number(value) > referralModel.pageQty) return prev
                                    return Number(value)
                                })}}
                                inputValue={referralModel.page ? referralModel.page.toString() : ''}
                                sx={autocompleteNumberStyle}
                                freeSolo forcePopupIcon disableClearable
                                filterOptions={(opt)=>opt}
                                popupIcon={<KeyboardArrowRightRoundedIcon />}
                                PaperComponent={(props) => (<Paper elevation={2} {...props} sx={autocompletePaper} />)}
                                PopperComponent={(props) => ( <Popper {...props} sx={autocompletePopper} />)}
                                options={Array.from(new Array(referralModel.pageQty)).map((e, i)=>i+1)}
                                renderInput={(params)=><TextField {...params} placeholder="0"/>}
                            />
                            из {referralModel.pageQty}
                        </Box>
                    </Box>

                    <ViewSettingsModal 
                        open={referralModel.openViewSettings} 
                        setOpen={referralModel.setOpenViewSettings} 
                        columns={referralModel.columns}
                        setColumns={referralModel.setColumns}
                    />

                </Paper>

            </TabPanel>

            <TabPanel value={'MED_JOURNAL'} sx={{width: '100%', height: '100%', margin: '0px', padding: '0px'}}>

                <Paper
                    sx={{
                        margin:'17px 16px 15px 16px',
                        boxShadow: 'none',
                        padding: '16px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px'
                    }}
                >


                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontFamily: 'Roboto', fontWeight: '400', fontSize: '20px', lineHeight: '23px' }}>
                            Медицинский журнал
                        </Typography>
                        <Box sx={{ display: 'flex', gap: '16px' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    ...buttonStyle, backgroundColor: activeColor,
                                    '&:hover': { backgroundColor: '#007DB8', boxShadow: 'none' },
                                    fontFamily: 'Roboto',
                                    fontWeight: '500',
                                    fontSize: '14px',
                                    lineHeight: '23px',
                                    padding: '8px 12px',
                                    minWidth: '0px',
                                }}
                                disabled={reportModel.reportsApi === undefined}
                                onClick={() => medJournalModel.setOpenViewSettings(!medJournalModel.openViewSettings)}
                            >
                                <GearIcon />
                            </Button>
                        </Box>
                    </Box>

                    <CustomTable openDrawer={false} data={medJournalModel.medJournals} columns={medJournalModel.columns}></CustomTable>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', color: '#565656' }}>
                            Показывать
                            <Autocomplete
                                onInputChange={(_, value) => {medJournalModel.setPerPage((prev:number)=>{
                                    if (!value.match(/^(\s*|\d+)$/)) return prev
                                    if (value.length > 1 && value[0] === '0') return prev
                                    if (Number(value) > 50) return prev
                                    return Number(value)
                                })}}
                                inputValue={medJournalModel.perPage ? medJournalModel.perPage.toString() : ''}
                                sx={autocompleteNumberStyle}
                                freeSolo forcePopupIcon disableClearable
                                filterOptions={(opt)=>opt}
                                popupIcon={<KeyboardArrowRightRoundedIcon />}
                                PaperComponent={(props) => (<Paper elevation={2} {...props} sx={autocompletePaper} />)}
                                PopperComponent={(props) => ( <Popper {...props} sx={autocompletePopper} />)}
                                options={Array.from(new Array(50)).map((e, i)=>i+1)}
                                renderInput={(params)=><TextField {...params} placeholder="0"/>}
                            />
                            из {50}
                        </Box>
                        <Pagination
                            count={medJournalModel.pageQty}
                            page={medJournalModel.page}
                            onChange={(_, num) => medJournalModel.changePage(num)}
                            className={classes.root}
                            variant="outlined" shape="rounded"
                            sx={{
                                //marginY: 3, marginX: "auto",
                                '&  .Mui-selected': {
                                    backgroundColor: '#009FDA !important',
                                    color: 'white !important'
                                },
                                '& .Mui-selected:hover': {
                                    backgroundColor: 'rgb(0,159,218) !important',
                                    color: 'white !important'
                                },
                            }}
                            renderItem={(item) => (
                                <PaginationItem

                                    {...item}

                                    component={NavLink}
                                    to={`/reports/${item.page}`}
                                // to={'/organisations'}

                                />
                            )}
                        />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', color: '#565656' }}>
                            Страница
                            <Autocomplete
                                onInputChange={(_, value) => {medJournalModel.changePage((prev:number)=>{
                                    if (!value.match(/^(\s*|\d+)$/)) return prev
                                    if (value.length > 1 && value[0] === '0') return prev
                                    if (Number(value) > medJournalModel.pageQty) return prev
                                    return Number(value)
                                })}}
                                inputValue={medJournalModel.page ? medJournalModel.page.toString() : ''}
                                sx={autocompleteNumberStyle}
                                freeSolo forcePopupIcon disableClearable
                                filterOptions={(opt)=>opt}
                                popupIcon={<KeyboardArrowRightRoundedIcon />}
                                PaperComponent={(props) => (<Paper elevation={2} {...props} sx={autocompletePaper} />)}
                                PopperComponent={(props) => ( <Popper {...props} sx={autocompletePopper} />)}
                                options={Array.from(new Array(medJournalModel.pageQty)).map((e, i)=>i+1)}
                                renderInput={(params)=><TextField {...params} placeholder="0"/>}
                            />
                            из {medJournalModel.pageQty}
                        </Box>
                    </Box>

                    <ViewSettingsModal 
                        open={medJournalModel.openViewSettings} 
                        setOpen={medJournalModel.setOpenViewSettings} 
                        columns={medJournalModel.columns}
                        setColumns={medJournalModel.setColumns}
                    />

                </Paper>

            </TabPanel>

            </TabContext>

        </Box>
    )
}